import I18n from 'I18n';
import SetPropertyActionMetadata from 'automation-ui-action-features/actions/set-property/SetPropertyActionMetadata';
import * as SetPropertyActionMetadataKeys from 'automation-ui-action-features/actions/set-property/SetPropertyActionMetadataKeys';
import StaticBranchActionMetadata from 'automation-ui-action-features/actions/static-branch/StaticBranchActionMetadata';
import * as StaticBranchActionMetadataKeys from 'automation-ui-action-features/actions/static-branch/StaticBranchActionMetadataKeys';
import StaticBranchInput from 'automation-ui-action-features/actions/static-branch/StaticBranchInput';
import ActionSuggestionGroup from 'automation-ui-action-features/components/suggestions/ActionSuggestionGroup';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import ConnectionKeys from 'automation-ui-action-features/constants/ConnectionKeys';
import ConnectionTypes from 'automation-ui-action-features/constants/ConnectionTypes';
import * as StaticBranchKeys from 'automation-ui-action-features/constants/StaticBranchKeys';
import TargetProperty from 'automation-ui-action-features/object-type-properties/TargetProperty';
import * as TargetPropertySourceTypes from 'automation-ui-action-features/object-type-properties/TargetPropertySourceTypes';
import Action from 'automation-ui-action-features/records/Action';
import StaticBranch from 'automation-ui-action-features/records/StaticBranch';
import StaticBranchConnection from 'automation-ui-action-features/records/connection/StaticBranchConnection';
import FieldDataIdentifier from 'automation-ui-flow-core/fields/FieldDataIdentifier';
import PropertyValue from 'automation-ui-flow-core/fields/PropertyValue';
import * as PropertyValueTypes from 'automation-ui-flow-core/fields/PropertyValueTypes';
import { NON_CONTEXTUAL_SOURCE_APPS } from 'automation-ui-source-apps/constants/WorkflowsAppSupportedSourceApps';
import { INVOICE_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
export default new Map([[ActionTypes.DELAY_UNTIL_DATE, new ActionSuggestionGroup({
  description: 'automation-ui-action-features.action-suggestions.delay-until-date.description_cob',
  shouldAppear: ({
    sourceApp
  }) => {
    return NON_CONTEXTUAL_SOURCE_APPS.includes(sourceApp);
  },
  suggestions: [{
    id: 'addValueEqualsBranchAfterDelayUntilDate',
    selected: true,
    name: 'automation-ui-action-features.action-suggestions.delay-until-date.optInToAddingABranch',
    generateAction: currentAction => {
      const dateType = currentAction.getMetadata().getDate().getType();
      const connection = dateType === PropertyValueTypes.OBJECT_PROPERTY ? new StaticBranchConnection({
        [ConnectionKeys.CONNECTION_TYPE]: ConnectionTypes.STATIC_BRANCH_CONNECTION,
        [ConnectionKeys.STATIC_BRANCHES]: [new StaticBranch({
          [StaticBranchKeys.BRANCH_NAME]: 'DATE_MET_AS_PLANNED'
        }), new StaticBranch({
          [StaticBranchKeys.BRANCH_NAME]: 'DATE_HAPPENED_IN_PAST'
        })],
        [ConnectionKeys.DEFAULT_BRANCH_NAME]: I18n.text('automation-ui-action-features.action-suggestions.delay-until-date.defaultBranchName.propertyDate')
      }) : new StaticBranchConnection({
        [ConnectionKeys.CONNECTION_TYPE]: ConnectionTypes.STATIC_BRANCH_CONNECTION,
        [ConnectionKeys.STATIC_BRANCHES]: [new StaticBranch({
          [StaticBranchKeys.BRANCH_NAME]: 'DATE_MET_AS_PLANNED'
        })],
        [ConnectionKeys.DEFAULT_BRANCH_NAME]: I18n.text('automation-ui-action-features.action-suggestions.delay-until-date.defaultBranchName.staticDate')
      });
      return new Action({
        actionType: ActionTypes.STATIC_BRANCH,
        metadata: new StaticBranchActionMetadata({
          [StaticBranchActionMetadataKeys.ACTION_TYPE]: ActionTypes.STATIC_BRANCH,
          [StaticBranchActionMetadataKeys.INPUT_TYPE]: PropertyValueTypes.FIELD_DATA,
          [StaticBranchActionMetadataKeys.INPUT_VALUE]: new StaticBranchInput({
            type: PropertyValueTypes.FIELD_DATA,
            identifier: new FieldDataIdentifier({
              actionId: currentAction.getActionId(),
              dataKey: 'hs_delay_status'
            })
          })
        }),
        connection
      });
    }
  }],
  supportUrl: null
})], [ActionTypes.FORMULA, new ActionSuggestionGroup({
  description: 'automation-ui-action-features.action-suggestions.formula.description_cob',
  shouldAppear: ({
    flowObjectTypeId
  }) => flowObjectTypeId !== INVOICE_TYPE_ID,
  suggestions: [{
    id: 'addCopyPropertyAfterFormatData',
    selected: true,
    name: 'automation-ui-action-features.action-suggestions.formula.optInToCopyFormattedDataToProperty',
    shouldSaveAutomatically: false,
    generateAction: currentAction => {
      let targetPropertyName = null;
      const variableContexts = currentAction.getMetadata().getVariableContexts();
      if (variableContexts.size === 1) {
        const variable = variableContexts.get(0).get('value');
        if (variable.getType() === PropertyValueTypes.OBJECT_PROPERTY) {
          targetPropertyName = variable.getPropertyName();
        }
      }
      return new Action({
        actionType: ActionTypes.SET_PROPERTY,
        metadata: new SetPropertyActionMetadata({
          [SetPropertyActionMetadataKeys.ACTION_TYPE]: ActionTypes.SET_PROPERTY,
          [SetPropertyActionMetadataKeys.VALUE]: new PropertyValue({
            type: PropertyValueTypes.FIELD_DATA,
            identifier: new FieldDataIdentifier({
              actionId: currentAction.getActionId(),
              dataKey: 'formula_result_output'
            })
          }),
          [SetPropertyActionMetadataKeys.TARGET_PROPERTY]: new TargetProperty({
            source: TargetPropertySourceTypes.OBJECT,
            propertyName: targetPropertyName
          })
        })
      });
    }
  }]
})], [ActionTypes.WAIT_UNTIL, new ActionSuggestionGroup({
  description: 'automation-ui-action-features.action-suggestions.wait-until.description_cob',
  shouldAppear: ({
    sourceApp
  }) => {
    return NON_CONTEXTUAL_SOURCE_APPS.includes(sourceApp);
  },
  suggestions: [{
    id: 'addValueEqualsBranchAfterDelayUntilEvent',
    selected: true,
    name: 'automation-ui-action-features.action-suggestions.wait-until.optInToAddingABranch',
    generateAction: currentAction => new Action({
      actionType: ActionTypes.STATIC_BRANCH,
      metadata: new StaticBranchActionMetadata({
        [StaticBranchActionMetadataKeys.ACTION_TYPE]: ActionTypes.STATIC_BRANCH,
        [StaticBranchActionMetadataKeys.INPUT_TYPE]: PropertyValueTypes.FIELD_DATA,
        [StaticBranchActionMetadataKeys.INPUT_VALUE]: new StaticBranchInput({
          type: PropertyValueTypes.FIELD_DATA,
          identifier: new FieldDataIdentifier({
            actionId: currentAction.getActionId(),
            dataKey: 'hs_event_criteria_met'
          })
        })
      }),
      connection: new StaticBranchConnection({
        [ConnectionKeys.CONNECTION_TYPE]: ConnectionTypes.STATIC_BRANCH_CONNECTION,
        [ConnectionKeys.STATIC_BRANCHES]: [new StaticBranch({
          [StaticBranchKeys.BRANCH_NAME]: 'true'
        })],
        [ConnectionKeys.DEFAULT_BRANCH_NAME]: I18n.text('automation-ui-action-features.action-suggestions.wait-until.defaultBranchName')
      })
    })
  }],
  supportUrl: null
})]]);